import { newPassword } from './new-password';
import { resetPassword } from './reset-password';

export const PasswordAPI = {
  resetPassword,
  newPassword,
};
